import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function DirectLegBusiness() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let user = "";

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const [search, setSearch] = useState(user);

  let arrayLeft = [];
  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/Adminreport",
        {
          loginid: userId,
          uid: search,
          report: "directLegBusiness",
          fdate: "",
          tdate: "",
          status: 0,
          level: 0,
          Position: 0,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("Direct team", responceRight?.data?.data);
      // console.log("Direct team Output", responceRight?.data?.dataOutput);
      // setTotalId(responceRight?.data?.dataOutput?.totalid);
      // setTotalAmount(responceRight?.data?.dataOutput?.totalamount);
      responceRight = responceRight?.data?.data?.[0];
      setleftreferralApi([]);

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          uid: item.uid,
          f_name: item.wallet,
          selfbv: item.selfbv,
          teambv: item.teambv,
          gbv: item.gbv,
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      //{ Header: "Wallet Address", accessor: "f_name" },
      { Header: "Self Business", accessor: "selfbv" },
      { Header: "Team Business", accessor: "teambv" },
      { Header: "Total Business", accessor: "gbv" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Direct Leg Business</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="userid"
                        ng-model="p.userid"
                        class="form-control in-ip-1"
                        placeholder="Enter User Id"
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>

                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => referral_API()}
                        class="btn btn-primary"
                        value="Search"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <h4>
                      <span></span>
                    </h4>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DirectLegBusiness;
